import styled from "styled-components";

import { AuthTitle } from "../styles";
import { colors } from "application/styles/colors";

interface StyledProps {
  error?: boolean;
  checked: boolean;
}

export const SignUpContent = styled.div`
  width: calc(100% - 32px);
  max-width: 614px;
  padding: 0 16px;

  @media only screen and (max-width: 1023px) {
    width: 674px;
  }

  @media only screen and (max-width: 674px) {
    width: calc(100% - 32px);
    padding: 0 16px;
  }
`;

export const SignUpTitle = styled(AuthTitle)`
  margin-bottom: 24px;
  position: relative;
  z-index: 10;

  @media only screen and (max-width: 674px) {
    display: none;
  }
`;

export const SignUpSubTitle = styled.h3`
  margin-bottom: 32px;
  /* Font style */
  font-family: "Helvetica";
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.font_grey};

  @media only screen and (max-width: 674px) {
    margin-bottom: 20px;
  }
`;

export const BoldText = styled.span`
  font-family: "Helvetica";
  font-style: normal;
  font-weight: 600;
  text-align: center;
  color: ${colors.font_grey};
`;

export const SignUpInfo = styled.span`
  /* Font style */
  font-family: "Helvetica";
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: ${colors.font_grey};
`;

export const TermsContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 25px 0 16px 0;

  & > div:first-child {
    margin-right: 8px;
  }
`;

export const TermsAction = styled.span`
  font-family: "Helvetica";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.ochre};
  cursor: pointer;
`;

export const RegistrationBtn = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  & > button {
    max-width: 287px;
  }
`;

export const AgreeContainer = styled.div`
  display: flex;
  margin-top: 56px;

  & > div:first-child {
    margin-right: 8px;
  }

  @media only screen and (max-width: 674px) {
    margin-top: 0;
    margin-bottom: 12px;
  }
`;

export const PasswordTip = styled.ul`
  list-style: inside;
  padding-left: 5px;
  li span {
    left: -5px;
    position: relative;
  }
`;

export const InfoList = styled.ul`
  list-style: inside;
  margin-bottom: 12px;
  li {
    padding-left: 20px;
    text-indent: -20px;
  }
  li span {
    left: -5px;
    position: relative;
  }
`;

export const MobileConfirmButton = styled.div`
  width: 642px;
  margin: 0 auto 24px;

  @media only screen and (max-width: 674px) {
    width: 100%;
  }
`;

export const CheckBoxContainer = styled.div<StyledProps>`
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  min-width: 16px;
  height: 16px;
  box-sizing: border-box;
  cursor: pointer;
  background-color: ${({ checked }) =>
    checked ? colors.blue_default : "transparent"};
  border: ${({ error, checked }) =>
    error
      ? `2px solid ${colors.red}`
      : checked
      ? "none"
      : `1px solid ${colors.stroke_grey}`};

  @media only screen and (max-width: 674px) {
    width: 20px;
    min-width: 20px;
    height: 20px;
  }
`;
